/** Whether the email's domain is exactly one of the given domains, case
 * insensitive and ignoring surrounding whitespace. Domains may be given with or
 * without a leading `@`. The whole domain is compared, so partial matches are not allowed.
 * @param email Email to check
 * @param domains Domains to match against, as a list or a comma separated string
 * @returns boolean
 */
export function isEmailInDomains(
  email: string | null | undefined,
  domains: string | string[]
): boolean {
  const atIndex = email?.lastIndexOf('@') ?? -1;
  if (!email || atIndex === -1) return false;
  const emailDomain = normalizeDomain(email.slice(atIndex));
  const domainList = Array.isArray(domains) ? domains : domains.split(',');
  return domainList.some((domain) => normalizeDomain(domain) === emailDomain);
}

function normalizeDomain(domain: string): string {
  return domain.trim().replace(/^@/, '').toLowerCase();
}
